import React, { useContext } from "react";
import "./PageFourteen.scss";
import { BuildingsContext } from "../../../bContext";

import zdj from "../../../assets/zdjecia.PNG"
import zdjEn from "../../../assets/photoEn.png"

function PageFourteen() {
  const { switchToEnglish} = useContext(
    BuildingsContext
  );
  return (
    <>
    <div className="pageFourteen">
      <div className="speech-bubble4">
      {switchToEnglish === false ? 
        <p className="first">
          Za pomocą menu, możemy obejrzeć zdjęcia wybranego obiektu.
        </p>
        :
        <p className="first">
        Using the menu, we can view photos of the selected object
      </p>
      }
        <div className="inner-triangle-right4"></div>
      </div>
       <div className="menu-pg4" style={{backgroundImage: !switchToEnglish ? `url(${zdj})` : `url(${zdjEn})` , height: switchToEnglish && "5rem" }}></div> 

      <div>
      <div className="speech-bubble5">
      {switchToEnglish === false ? 
        <p className="first">
         Zdjęcia możemy przeglądać klikając w strzałki lewo lub prawo.
        </p>
        :
        <p className="first">
        The pictures can beviewed by clicking on the left or right arrows
       </p>
      }
        <div className="inner-triangle-right5"></div>
      </div>
      <div className="menu-pg5" ></div> 
        <div className="modal-header-ins"></div>
        <div className="modalbtn"></div>
        <div className="defaultbtn"></div>
      </div>
    </div>      
    </>
  );
}

export default PageFourteen;
